// src/services/admin/adminAwardAssign.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const adminAwardAssignApi = createApi({
  reducerPath: "adminAwardAssignApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/admin/adminAwards`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["AdminAwardAssign"],
  endpoints: (builder) => ({
    assignAward: builder.mutation({
      query: (payload) => ({
        url: "/assign",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "AdminAwardAssign", id: "LIST" }],
    }),
  }),
});

export const { useAssignAwardMutation } = adminAwardAssignApi;
export default adminAwardAssignApi;
export { adminAwardAssignApi };
